export default class ScrollNotice {
  constructor(rootNode, props) {
    this.props = props;
    rootNode.addEventListener('click', this.scrollDown.bind(this));
  }

  scrollDown() {
    window.scroll({
      top: this.getTargetScrollTop(),
      behavior: 'smooth',
    });
  }

  getTargetScrollTop() {
    if (this.props.scrollTarget && this.props.scrollTarget.length > 0) {
      const targetNode = document.querySelector(this.props.scrollTarget);

      if (targetNode) {
        return targetNode.offsetTop + targetNode.offsetHeight;
      }
    }

    return window.innerHeight;
  }
}
